// import { useState, useEffect, useCallback } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { initializeDeposit, verifyDeposit, getUser, apiClient } from "../../api/apiServices";
// import useAuthStatus from "../../hooks/useAuthStatus";
// import { useTradingConfig } from "../../hooks/useTradingConfig";
// import ServiceGate from "../../components/feature/ServiceGate";
// import { useServices } from "../../hooks/useServices";
// import { useAnalytics } from "../../hooks/useAnalytics";
// import FloatingSupportButton from "../../components/feature/FloatingSupportButton";


// const QUICK_AMOUNTS = [1000, 2000, 5000, 10000, 20000, 50000];

// // ── Virtual account card ──────────────────────────────────────
// function VirtualAccountSection({ user, percentFee = 0 }) {
//   const navigate          = useNavigate();
//   const [account,  setAccount]  = useState(null);
//   const [loading,  setLoading]  = useState(true);
//   const [creating, setCreating] = useState(false);
//   const [copied,   setCopied]   = useState(null); // "number" | "name"

//   const isKycApproved = user?.kycStatus === "approved" || user?.kycVerified;

//   useEffect(() => {
//     if (!isKycApproved) { setLoading(false); return; }
//     apiClient.get("/mtrade/wallet/virtual-account")
//       .then(r => { if (r.data.status) setAccount(r.data.data); })
//       .catch(() => {})
//       .finally(() => setLoading(false));
//   }, [isKycApproved]);

//   const handleGenerate = async () => {
//     setCreating(true);
//     try {
//       const r = await apiClient.post("/mtrade/wallet/virtual-account/create", { preferred_bank: "wema-bank" });
//       if (r.data.status) {
//         setAccount(r.data.data);
//         toast.success("Virtual account created!");
//       } else {
//         toast.error(r.data.message || "Failed to create account");
//       }
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Failed to create virtual account");
//     } finally { setCreating(false); }
//   };

//   const handleCopy = async (value, key) => {
//     await navigator.clipboard.writeText(value).catch(() => {});
//     setCopied(key);
//     setTimeout(() => setCopied(null), 2000);
//   };

//   // ── KYC not approved ────────────────────────────────────────
//   if (!isKycApproved) {
//     return (
//       <div className="bg-warning-light border border-warning-border rounded-2xl p-5 text-center space-y-3">
//         <div className="w-12 h-12 bg-warning-light rounded-2xl flex items-center justify-center mx-auto"
//           style={{ boxShadow: "inset 0 0 0 1px var(--color-warning-ring)" }}>
//           <i className="ri-shield-user-line text-warning text-xl" />
//         </div>
//         <div>
//           <p className="text-warning-text font-bold text-sm">KYC Required</p>
//           <p className="text-warning-text text-xs mt-1 leading-relaxed opacity-90">
//             Complete your identity verification to unlock a dedicated bank account number for direct transfers.
//           </p>
//         </div>
//         <button onClick={() => navigate("/kyc")}
//           className="w-full py-3 bg-warning hover:opacity-90 text-on-warning font-bold text-sm rounded-xl transition-colors active:scale-95">
//           Complete KYC Verification
//         </button>
//         <p className="text-warning-text text-[10px] opacity-80">Takes less than 2 minutes. Free.</p>
//       </div>
//     );
//   }

//   // ── Loading ──────────────────────────────────────────────────
//   if (loading) {
//     return <div className="h-40 bg-surface-hover rounded-2xl animate-pulse" />;
//   }

//   // ── No account yet ───────────────────────────────────────────
//   if (!account) {
//     return (
//       <div className="border-2 border-dashed border-border-strong rounded-2xl p-6 text-center space-y-4">
//         <div className="w-12 h-12 bg-brand-light rounded-2xl flex items-center justify-center mx-auto">
//           <i className="ri-bank-card-line text-brand text-xl" />
//         </div>
//         <div>
//           <p className="text-primary font-bold text-sm">No Virtual Account Yet</p>
//           <p className="text-muted text-xs mt-1 leading-relaxed">
//             Generate a free dedicated bank account number to receive transfers directly into your Easwallet — instantly.
//           </p>
//         </div>
//         <button onClick={handleGenerate} disabled={creating}
//           className="w-full py-3.5 bg-brand hover:bg-brand-hover disabled:opacity-60 text-on-brand font-bold text-sm rounded-2xl transition-all active:scale-95 flex items-center justify-center gap-2">
//           {creating
//             ? <><div className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />Generating…</>
//             : <><i className="ri-add-circle-line" />Generate Account Number</>}
//         </button>
//         <p className="text-muted text-[10px]">One-time setup. Your account number is permanent.</p>
//       </div>
//     );
//   }

//   // ── Account exists ───────────────────────────────────────────
//   // NOTE: this card is intentionally NOT tokenized to the light/dark
//   // surface scale. It's styled to look like a physical debit/virtual
//   // card (deep green gradient, embossed-style number), the same way a
//   // bank app keeps its card art fixed regardless of in-app theme —
//   // the card has its own "brand," distinct from the page chrome
//   // around it. Re-skinning it per theme would make it look like a
//   // generic content card instead of a card.
//   return (
//     <div className="space-y-4">
//       {/* Account card */}
//       <div className="rounded-2xl overflow-hidden relative"
//         style={{ background: "linear-gradient(135deg, #0a2e1e 0%, #0f4c35 60%, #1a6b4a 100%)" }}>
//         <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full opacity-10 pointer-events-none"
//           style={{ background: "radial-gradient(circle, #fff, transparent)" }} />
//         <div className="relative px-5 py-5">
//           <div className="flex items-center justify-between mb-4">
//             <div className="flex items-center gap-2">
//               <div className="w-7 h-7 bg-white/15 rounded-lg flex items-center justify-center">
//                 <i className="ri-bank-line text-white text-sm" />
//               </div>
//               <p className="text-white/70 text-xs font-medium">{account.bankName}</p>
//             </div>
//             <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-400/20 text-emerald-300">
//               Active
//             </span>
//           </div>
//           {/* Account number — large and prominent */}
//           <p className="text-white/50 text-[10px] mb-1">Account Number</p>
//           <div className="flex items-center justify-between">
//             <p className="text-white font-bold tracking-widest font-display"
//               style={{ fontSize: "1.4rem", letterSpacing: "0.18em" }}>
//               {account.accountNumber}
//             </p>
//             <button onClick={() => handleCopy(account.accountNumber, "number")}
//               className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-semibold bg-white/10 hover:bg-white/20 text-white transition-all">
//               <i className={`${copied === "number" ? "ri-check-line text-emerald-400" : "ri-file-copy-line"} text-sm`} />
//               {copied === "number" ? "Copied!" : "Copy"}
//             </button>
//           </div>
//           {/* Account name */}
//           <div className="flex items-center justify-between mt-2">
//             <p className="text-white/60 text-xs font-medium">{account.accountName}</p>
//             <button onClick={() => handleCopy(account.accountName, "name")}
//               className="text-white/40 text-[10px] hover:text-white/60 transition-colors">
//               {copied === "name" ? "Copied!" : "Copy name"}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Fee breakdown */}
//       {percentFee > 0 && (
//         <div className="bg-warning-light border border-warning-border rounded-2xl p-4 space-y-2">
//           <div className="flex items-center gap-2 mb-1">
//             <i className="ri-percent-line text-warning text-sm" />
//             <p className="text-warning-text text-xs font-bold uppercase tracking-wide">Transfer Fee</p>
//           </div>
//           {[
//             { send: 1000  },
//             { send: 5000  },
//             { send: 10000 },
//           ].map(({ send }) => {
//             const fee    = Math.round(send * percentFee / 100);
//             const credit = send - fee;
//             return (
//               <div key={send} className="flex items-center justify-between">
//                 <span className="text-warning-text text-xs">Send ₦{send.toLocaleString()}</span>
//                 <span className="text-faint text-xs">→</span>
//                 <span className="text-secondary text-xs font-semibold">
//                   ₦{credit.toLocaleString()} credited
//                   <span className="text-warning-text font-normal ml-1">(-₦{fee})</span>
//                 </span>
//               </div>
//             );
//           })}
//           <p className="text-warning-text text-[10px] mt-1 leading-relaxed opacity-90">
//             {percentFee}% fee applies to all bank transfers. The fee covers processing and platform costs.
//           </p>
//         </div>
//       )}

//       {/* How to use */}
//       <div className="bg-surface-muted rounded-2xl p-4 space-y-2.5">
//         <p className="text-secondary text-xs font-bold uppercase tracking-wider">How to fund via bank transfer</p>
//         {[
//           { step: "1", text: "Open your bank app or USSD" },
//           { step: "2", text: `Send to: ${account.bankName}` },
//           { step: "3", text: `Account: ${account.accountNumber}` },
//           { step: "4", text: `Wallet credits within seconds${percentFee > 0 ? ` (minus ${percentFee}% fee)` : ""}` },
//         ].map(s => (
//           <div key={s.step} className="flex items-center gap-3">
//             <div className="w-6 h-6 rounded-full bg-brand-light flex items-center justify-center flex-shrink-0">
//               <span className="text-brand-text text-[10px] font-bold">{s.step}</span>
//             </div>
//             <p className="text-secondary text-xs">{s.text}</p>
//           </div>
//         ))}
//       </div>

//       {/* Info note */}
//       <div className="flex items-start gap-2 px-3 py-2.5 bg-info-light border border-info-border rounded-xl">
//         <i className="ri-information-line text-info text-sm flex-shrink-0 mt-0.5" />
//         <p className="text-info-text text-xs leading-relaxed">
//           This account number is permanently yours. Transfers from any Nigerian bank credit your wallet instantly.
//           {percentFee > 0 && ` A ${percentFee}% processing fee is deducted from each transfer.`}
//         </p>
//       </div>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────
// export default function FiatDeposit() {
//   const { services }    = useServices();
//   const { track, conversion } = useAnalytics();
//   const navigate        = useNavigate();
//   const isAuthenticated = useAuthStatus();
//   const [searchParams]  = useSearchParams();

//   const [activeTab,      setActiveTab]      = useState("paystack"); // "paystack" | "transfer"
//   const [amount,         setAmount]         = useState("");
//   const [loading,        setLoading]        = useState(false);
//   const [verifying,      setVerifying]      = useState(false);
//   const [verified,       setVerified]       = useState(false);
//   const [verifiedAmount, setVerifiedAmount] = useState(0);
//   const [user,           setUser]           = useState(null);
//   const [userLoading,    setUserLoading]    = useState(true);

//   const { fees, limits } = useTradingConfig({ enabled: isAuthenticated });
//   const percentFee       = fees.depositFeePercent || 0;
//   const minDeposit       = limits.minDepositNGN   || 100;

//   const rawAmount    = Number(amount) || 0;
//   const isValid      = rawAmount >= minDeposit;
//   const feeAmount    = Math.round((percentFee / 100) * rawAmount);
//   const chargeAmount = rawAmount + feeAmount;

//   // ── Load user (for KYC check) ─────────────────────────────
//   useEffect(() => {
//     if (!isAuthenticated) { setUserLoading(false); return; }
//     getUser()
//       .then(d => { if (d?.status) setUser(d.user); })
//       .catch(console.error)
//       .finally(() => setUserLoading(false));
//   }, [isAuthenticated]);

//   // ── Handle Paystack redirect back ─────────────────────────
//   useEffect(() => {
//     const reference = searchParams.get("reference");
//     if (!reference) return;
//     (async () => {
//       setVerifying(true);
//       try {
//         const res = await verifyDeposit(reference);
//         if (res.status) {
//           setVerifiedAmount(res.amount);
//           setVerified(true);
//           const sym = res.symbol || "₦";
//           toast.success(`${sym}${res.amount.toLocaleString()} added to your wallet!`);
//         } else if (res.code === "VERIFY_PENDING") {
//           // Backend couldn't reach Paystack but tx may still complete via webhook
//           toast.info(res.message || "Payment is being confirmed — check your balance in a moment.");
//           navigate("/home");
//         } else {
//           toast.error(res.message || "Payment could not be confirmed");
//         }
//       } catch (err) {
//         const data = err?.response?.data;
//         if (data?.code === "VERIFY_PENDING") {
//           toast.info(data.message || "Payment is being confirmed — check your balance shortly.");
//           navigate("/home");
//         } else {
//           toast.error(data?.message || "Could not verify payment. Check your balance — it may already be credited.");
//         }
//       } finally { setVerifying(false); }
//     })();
//   }, []);

//   const handleDeposit = async () => {
//     if (!isValid || loading) return;
//     track.addToCart(rawAmount);
//     setLoading(true);
//     try {
//       const res = await initializeDeposit(rawAmount);
//       if (res.status) {
//         window.location.href = res.authorizationUrl;
//       } else {
//         toast.error(res.message || "Could not start payment");
//       }
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Failed to initialize payment");
//     } finally { setLoading(false); }
//   };

//   // ── Verifying screen ──────────────────────────────────────
//   if (verifying) {
//     return (
//       <div className="min-h-screen bg-bg flex flex-col items-center justify-center p-8 text-center">
//         <div className="w-16 h-16 border-4 border-t-transparent rounded-full animate-spin mb-6" style={{ borderColor: "var(--color-brand)", borderTopColor: "transparent" }} />
//         <h2 className="text-primary font-bold text-lg mb-2 font-display">Confirming your payment…</h2>
//         <p className="text-muted text-sm">Please wait, do not close this page</p>
//       </div>
//     );
//   }

//   // ── Success screen ────────────────────────────────────────
//   if (verified) {
    
//     return (
//       <div className="min-h-screen bg-bg flex flex-col pb-10">
//         <div className="px-5 pt-16 pb-12 text-center relative overflow-hidden" style={{ background: "var(--gradient-hero)" }}>
//           <div className="absolute inset-0 pointer-events-none" style={{ background: "var(--gradient-hero-sheen)" }} />
//           <div className="absolute top-0 right-0 w-40 h-40 rounded-full opacity-10"
//             style={{ background: "radial-gradient(circle, #fff 0%, transparent 70%)", transform: "translate(30%,-30%)" }} />
//           <div className="relative">
//             <div className="w-20 h-20 bg-white/20 rounded-full border-4 border-white/30 flex items-center justify-center mx-auto mb-4">
//               <i className="ri-checkbox-circle-fill text-white text-4xl" />
//             </div>
//             <h1 className="text-white text-2xl font-bold mb-1 font-display">
//               Deposit Successful!
//             </h1>
//             <p className="text-sm mb-4" style={{ color: "var(--gradient-hero-text-muted)" }}>Your wallet has been credited</p>
//             <p className="text-white text-4xl font-bold font-display">
//               ₦{verifiedAmount.toLocaleString()}
//             </p>
//           </div>
//         </div>
//         <div className="px-5 mt-6 space-y-3">
//           <div className="bg-surface rounded-2xl border border-border p-4">
//             {[
//               { label: "Credited to wallet", value: `₦${verifiedAmount.toLocaleString()}` },
//               { label: "Type",   value: "Naira Deposit" },
//               { label: "Status", value: "✅ Confirmed" },
//               { label: "Time",   value: new Date().toLocaleString("en-NG", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) },
//             ].map(row => (
//               <div key={row.label} className="flex justify-between items-center py-3 border-b border-border last:border-0">
//                 <span className="text-muted text-sm">{row.label}</span>
//                 <span className="text-primary font-semibold text-sm">{row.value}</span>
//               </div>
//             ))}
//           </div>
//           <button onClick={() => navigate("/home")}
//             className="w-full bg-brand hover:bg-brand-hover text-on-brand py-4 rounded-2xl font-bold text-sm transition-all active:scale-95">
//             Back to Home
//           </button>
//           <button onClick={() => { setVerified(false); setAmount(""); navigate("/deposit-fiat", { replace: true }); }}
//             className="w-full text-muted py-3 text-sm font-medium hover:text-secondary transition-colors">
//             Make Another Deposit
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // ── Main deposit form ─────────────────────────────────────
//   return (
//     <ServiceGate serviceKey="fiat_deposit" services={services} fullPage>
//       <div className="min-h-screen bg-bg pb-10 font-display">

//         <FloatingSupportButton user={user} />

//         {/* Header */}
//         <div className="bg-surface px-5 pt-12 pb-4 border-b border-border">
//           <div className="flex items-center gap-3">
//             <button onClick={() => navigate(-1)} className="w-9 h-9 rounded-xl bg-surface-hover flex items-center justify-center">
//               <i className="ri-arrow-left-line text-secondary text-lg" />
//             </button>
//             <div>
//               <h1 className="text-primary font-bold text-lg">Fund Wallet</h1>
//               <p className="text-muted text-xs">Choose how you want to deposit Naira</p>
//             </div>
//           </div>

//           {/* Method tabs */}
//           <div className="flex mt-4 bg-surface-hover rounded-2xl p-1 gap-1">
//             <button onClick={() => setActiveTab("paystack")}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-semibold transition-all ${
//                 activeTab === "paystack" ? "bg-surface text-primary shadow-card" : "text-muted"
//               }`}>
//               <i className="ri-bank-card-line" />Pay with Card / USSD
//             </button>
//             <button onClick={() => setActiveTab("transfer")}
//               className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-semibold transition-all ${
//                 activeTab === "transfer" ? "bg-surface text-primary shadow-card" : "text-muted"
//               }`}>
//               <i className="ri-bank-line" />Bank Transfer
//             </button>
//           </div>
//         </div>

//         <div className="px-5 pt-5 space-y-5">

//           {/* ── TAB: PAYSTACK ─────────────────────────────── */}
//           {activeTab === "paystack" && (
//             <>
//               {/* Info banner */}
//               <div className="bg-brand-light border border-brand-border rounded-2xl p-4 flex items-start gap-3">
//                 <i className="ri-shield-check-line text-brand text-xl mt-0.5 flex-shrink-0" />
//                 <div>
//                   <p className="text-brand-text text-sm font-semibold">Secured by Paystack</p>
//                   <p className="text-brand-text text-xs mt-0.5 opacity-90">
//                     Pay with card, bank transfer, or USSD. Funds reflect instantly after confirmation.
//                   </p>
//                 </div>
//               </div>

//               {/* Amount input */}
//               <div>
//                 <p className="text-secondary text-sm font-semibold mb-3">
//                   Amount to credit <span className="text-muted font-normal">(min ₦{minDeposit.toLocaleString()})</span>
//                 </p>
//                 <div className={`bg-surface border-2 rounded-2xl flex items-center px-4 transition-colors ${
//                   amount && !isValid ? "border-danger-border" : "border-border-strong focus-within:border-brand"
//                 }`}>
//                   <span className="text-muted font-bold text-lg mr-2">₦</span>
//                   <input
//                     type="number"
//                     value={amount}
//                     onChange={e => setAmount(e.target.value)}
//                     onKeyDown={e => e.key === "Enter" && handleDeposit()}
//                     placeholder="0.00"
//                     className="flex-1 py-4 outline-none text-primary text-xl font-bold bg-transparent placeholder:text-faint"
//                   />
//                 </div>
//                 {amount && !isValid && (
//                   <p className="text-danger-text text-xs mt-1.5 px-1">Minimum deposit is ₦{minDeposit.toLocaleString()}</p>
//                 )}
//               </div>

//               {/* Quick amounts */}
//               <div>
//                 <p className="text-muted text-xs font-semibold mb-2">Quick amounts</p>
//                 <div className="grid grid-cols-3 gap-2">
//                   {QUICK_AMOUNTS.map(amt => (
//                     <button key={amt} onClick={() => setAmount(String(amt))}
//                       className={`py-2.5 rounded-xl text-sm font-semibold border transition-all ${
//                         amount === String(amt) ? "bg-brand text-on-brand border-brand" : "bg-surface text-secondary border-border-strong hover:border-brand-border"
//                       }`}>
//                       ₦{amt >= 1000 ? `${amt / 1000}k` : amt}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               {/* Fee breakdown */}
//               {isValid && (
//                 <div className="bg-surface-muted border border-border rounded-2xl p-4 space-y-2.5">
//                   <div className="flex justify-between text-sm">
//                     <span className="text-muted">Wallet credit</span>
//                     <span className="font-semibold text-primary">₦{rawAmount.toLocaleString()}</span>
//                   </div>
//                   <div className="flex justify-between text-sm">
//                     <span className="text-muted">Service fee ({percentFee}%)</span>
//                     <span className="font-semibold text-danger-text">+ ₦{feeAmount.toLocaleString()}</span>
//                   </div>
//                   <div className="h-px bg-border" />
//                   <div className="flex justify-between text-sm">
//                     <span className="text-primary font-bold">You pay (Paystack)</span>
//                     <span className="font-bold text-primary text-base">₦{chargeAmount.toLocaleString()}</span>
//                   </div>
//                   <p className="text-muted text-[10px] leading-relaxed">
//                     ₦{rawAmount.toLocaleString()} will be credited to your wallet. The ₦{feeAmount.toLocaleString()} fee covers payment processing.
//                   </p>
//                 </div>
//               )}

//               {/* Pay button */}
//               <button onClick={handleDeposit} disabled={!isValid || loading}
//                 className="w-full bg-brand hover:bg-brand-hover disabled:bg-surface-hover disabled:text-faint text-on-brand py-4 rounded-2xl font-bold text-sm transition-all active:scale-95 flex items-center justify-center gap-2">
//                 {loading
//                   ? <><div className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />Redirecting to Paystack…</>
//                   : isValid
//                     ? <><i className="ri-bank-card-line" />Pay ₦{chargeAmount.toLocaleString()} via Paystack</>
//                     : "Enter an amount to continue"}
//               </button>

//               <p className="text-center text-xs text-muted pb-2">
//                 🔒 Your payment is encrypted and secured by Paystack
//               </p>
//             </>
//           )}

//           {/* ── TAB: BANK TRANSFER (Virtual Account) ─────── */}
//           {activeTab === "transfer" && (
//   <>
//     {/* Updated banner — shows actual fee */}
//     <div className="bg-surface-muted border border-border rounded-2xl p-4 flex items-start gap-3">
//       <i className="ri-bank-line text-muted text-xl mt-0.5 flex-shrink-0" />
//       <div>
//         <p className="text-secondary text-sm font-semibold">Direct Bank Transfer</p>
//         <p className="text-muted text-xs mt-0.5 leading-relaxed">
//           Transfer to your dedicated account number below.
//           {percentFee > 0
//             ? ` A ${percentFee}% fee applies — transferring ₦10,000 credits ₦${(10000 - Math.round(10000 * percentFee / 100)).toLocaleString()} to your wallet.`
//             : " Your full transfer amount is credited instantly."}
//         </p>
//       </div>
//     </div>

//     {userLoading ? (
//       <div className="h-40 bg-surface-hover rounded-2xl animate-pulse" />
//     ) : (
//       <VirtualAccountSection user={user} percentFee={percentFee} />
//     )}
//   </>
// )}

//         </div>
//       </div>
//     </ServiceGate>
//   );
// }


import { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { initializeDeposit, verifyDeposit, getUser, apiClient } from "../../api/apiServices";
import useAuthStatus from "../../hooks/useAuthStatus";
import { useTradingConfig } from "../../hooks/useTradingConfig";
import ServiceGate from "../../components/feature/ServiceGate";
import { useServices } from "../../hooks/useServices";
import { useAnalytics } from "../../hooks/useAnalytics";
import FloatingSupportButton from "../../components/feature/FloatingSupportButton";

const PENDING_DEPOSIT_KEY = "easwallet_pending_deposit";

const QUICK_AMOUNTS = [1000, 2000, 5000, 10000, 20000, 50000];

function savePendingDeposit(deposit, expiresAt) {
  try {
    localStorage.setItem(PENDING_DEPOSIT_KEY, JSON.stringify({ deposit, expiresAt }));
  } catch {}
}

function loadPendingDeposit() {
  try {
    const raw = localStorage.getItem(PENDING_DEPOSIT_KEY);
    if (!raw) return null;
    const { deposit, expiresAt } = JSON.parse(raw);
    if (!deposit || !expiresAt || expiresAt <= Date.now()) {
      localStorage.removeItem(PENDING_DEPOSIT_KEY);
      return null;
    }
    return { deposit, expiresAt };
  } catch {
    return null;
  }
}

function clearPendingDeposit() {
  try { localStorage.removeItem(PENDING_DEPOSIT_KEY); } catch {}
}

// ── Virtual account card ──────────────────────────────────────
function VirtualAccountSection({ user, percentFee = 0 }) {
  const navigate          = useNavigate();
  const [account,  setAccount]  = useState(null);
  const [loading,  setLoading]  = useState(true);
  const [creating, setCreating] = useState(false);
  const [copied,   setCopied]   = useState(null); // "number" | "name"

  const isKycApproved = user?.kycStatus === "approved" || user?.kycVerified;

  useEffect(() => {
    if (!isKycApproved) { setLoading(false); return; }
    apiClient.get("/mtrade/wallet/virtual-account")
      .then(r => { if (r.data.status) setAccount(r.data.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isKycApproved]);

  const handleGenerate = async () => {
    setCreating(true);
    try {
      const r = await apiClient.post("/mtrade/wallet/virtual-account/create", { preferred_bank: "wema-bank" });
      if (r.data.status) {
        setAccount(r.data.data);
        toast.success("Virtual account created!");
      } else {
        toast.error(r.data.message || "Failed to create account");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to create virtual account");
    } finally { setCreating(false); }
  };

  const handleCopy = async (value, key) => {
    await navigator.clipboard.writeText(value).catch(() => {});
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  };

  // ── KYC not approved ────────────────────────────────────────
  if (!isKycApproved) {
    return (
      <div className="bg-warning-light border border-warning-border rounded-2xl p-5 text-center space-y-3">
        <div className="w-12 h-12 bg-warning-light rounded-2xl flex items-center justify-center mx-auto"
          style={{ boxShadow: "inset 0 0 0 1px var(--color-warning-ring)" }}>
          <i className="ri-shield-user-line text-warning text-xl" />
        </div>
        <div>
          <p className="text-warning-text font-bold text-sm">KYC Required</p>
          <p className="text-warning-text text-xs mt-1 leading-relaxed opacity-90">
            Complete your identity verification to unlock a dedicated bank account number for direct transfers.
          </p>
        </div>
        <button onClick={() => navigate("/kyc")}
          className="w-full py-3 bg-warning hover:opacity-90 text-on-warning font-bold text-sm rounded-xl transition-colors active:scale-95">
          Complete KYC Verification
        </button>
        <p className="text-warning-text text-[10px] opacity-80">Takes less than 2 minutes. Free.</p>
      </div>
    );
  }

  // ── Loading ──────────────────────────────────────────────────
  if (loading) {
    return <div className="h-40 bg-surface-hover rounded-2xl animate-pulse" />;
  }

  // ── No account yet ───────────────────────────────────────────
  if (!account) {
    return (
      <div className="border-2 border-dashed border-border-strong rounded-2xl p-6 text-center space-y-4">
        <div className="w-12 h-12 bg-brand-light rounded-2xl flex items-center justify-center mx-auto">
          <i className="ri-bank-card-line text-brand text-xl" />
        </div>
        <div>
          <p className="text-primary font-bold text-sm">No Virtual Account Yet</p>
          <p className="text-muted text-xs mt-1 leading-relaxed">
            Generate a free dedicated bank account number to receive transfers directly into your Easwallet — instantly.
          </p>
        </div>
        <button onClick={handleGenerate} disabled={creating}
          className="w-full py-3.5 bg-brand hover:bg-brand-hover disabled:opacity-60 text-on-brand font-bold text-sm rounded-2xl transition-all active:scale-95 flex items-center justify-center gap-2">
          {creating
            ? <><div className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />Generating…</>
            : <><i className="ri-add-circle-line" />Generate Account Number</>}
        </button>
        <p className="text-muted text-[10px]">One-time setup. Your account number is permanent.</p>
      </div>
    );
  }

  // ── Account exists ───────────────────────────────────────────
  // NOTE: this card is intentionally NOT tokenized to the light/dark
  // surface scale. It's styled to look like a physical debit/virtual
  // card (deep green gradient, embossed-style number), the same way a
  // bank app keeps its card art fixed regardless of in-app theme —
  // the card has its own "brand," distinct from the page chrome
  // around it. Re-skinning it per theme would make it look like a
  // generic content card instead of a card.
  return (
    <div className="space-y-4">
      {/* Account card */}
      <div className="rounded-2xl overflow-hidden relative"
        style={{ background: "linear-gradient(135deg, #0a2e1e 0%, #0f4c35 60%, #1a6b4a 100%)" }}>
        <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full opacity-10 pointer-events-none"
          style={{ background: "radial-gradient(circle, #fff, transparent)" }} />
        <div className="relative px-5 py-5">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 bg-white/15 rounded-lg flex items-center justify-center">
                <i className="ri-bank-line text-white text-sm" />
              </div>
              <p className="text-white/70 text-xs font-medium">{account.bankName}</p>
            </div>
            <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-400/20 text-emerald-300">
              Active
            </span>
          </div>
          {/* Account number — large and prominent */}
          <p className="text-white/50 text-[10px] mb-1">Account Number</p>
          <div className="flex items-center justify-between">
            <p className="text-white font-bold tracking-widest font-display"
              style={{ fontSize: "1.4rem", letterSpacing: "0.18em" }}>
              {account.accountNumber}
            </p>
            <button onClick={() => handleCopy(account.accountNumber, "number")}
              className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-semibold bg-white/10 hover:bg-white/20 text-white transition-all">
              <i className={`${copied === "number" ? "ri-check-line text-emerald-400" : "ri-file-copy-line"} text-sm`} />
              {copied === "number" ? "Copied!" : "Copy"}
            </button>
          </div>
          {/* Account name */}
          <div className="flex items-center justify-between mt-2">
            <p className="text-white/60 text-xs font-medium">{account.accountName}</p>
            <button onClick={() => handleCopy(account.accountName, "name")}
              className="text-white/40 text-[10px] hover:text-white/60 transition-colors">
              {copied === "name" ? "Copied!" : "Copy name"}
            </button>
          </div>
        </div>
      </div>

      {/* Fee breakdown */}
      {percentFee > 0 && (
        <div className="bg-warning-light border border-warning-border rounded-2xl p-4 space-y-2">
          <div className="flex items-center gap-2 mb-1">
            <i className="ri-percent-line text-warning text-sm" />
            <p className="text-warning-text text-xs font-bold uppercase tracking-wide">Transfer Fee</p>
          </div>
          {[
            { send: 1000  },
            { send: 5000  },
            { send: 10000 },
          ].map(({ send }) => {
            const fee    = Math.round(send * percentFee / 100);
            const credit = send - fee;
            return (
              <div key={send} className="flex items-center justify-between">
                <span className="text-warning-text text-xs">Send ₦{send.toLocaleString()}</span>
                <span className="text-faint text-xs">→</span>
                <span className="text-secondary text-xs font-semibold">
                  ₦{credit.toLocaleString()} credited
                  <span className="text-warning-text font-normal ml-1">(-₦{fee})</span>
                </span>
              </div>
            );
          })}
          <p className="text-warning-text text-[10px] mt-1 leading-relaxed opacity-90">
            {percentFee}% fee applies to all bank transfers. The fee covers processing and platform costs.
          </p>
        </div>
      )}

      {/* How to use */}
      <div className="bg-surface-muted rounded-2xl p-4 space-y-2.5">
        <p className="text-secondary text-xs font-bold uppercase tracking-wider">How to fund via bank transfer</p>
        {[
          { step: "1", text: "Open your bank app or USSD" },
          { step: "2", text: `Send to: ${account.bankName}` },
          { step: "3", text: `Account: ${account.accountNumber}` },
          { step: "4", text: `Wallet credits within seconds${percentFee > 0 ? ` (minus ${percentFee}% fee)` : ""}` },
        ].map(s => (
          <div key={s.step} className="flex items-center gap-3">
            <div className="w-6 h-6 rounded-full bg-brand-light flex items-center justify-center flex-shrink-0">
              <span className="text-brand-text text-[10px] font-bold">{s.step}</span>
            </div>
            <p className="text-secondary text-xs">{s.text}</p>
          </div>
        ))}
      </div>

      {/* Info note */}
      <div className="flex items-start gap-2 px-3 py-2.5 bg-info-light border border-info-border rounded-xl">
        <i className="ri-information-line text-info text-sm flex-shrink-0 mt-0.5" />
        <p className="text-info-text text-xs leading-relaxed">
          This account number is permanently yours. Transfers from any Nigerian bank credit your wallet instantly.
          {percentFee > 0 && ` A ${percentFee}% processing fee is deducted from each transfer.`}
        </p>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
export default function FiatDeposit() {
  const { services }    = useServices();
  const { track, conversion } = useAnalytics();
  const navigate        = useNavigate();
  const isAuthenticated = useAuthStatus();
  const [searchParams]  = useSearchParams();

  const [activeTab,      setActiveTab]      = useState("transfer"); // "paystack" | "transfer"
  const [amount,         setAmount]         = useState("");
  const [loading,        setLoading]        = useState(false);
  const [verifying,      setVerifying]      = useState(false);
  const [verified,       setVerified]       = useState(false);
  const [verifiedAmount, setVerifiedAmount] = useState(0);
  const [user,           setUser]           = useState(null);
  const [userLoading,    setUserLoading]    = useState(true);
  // NEW: some gateways (IvoryPay) don't return a redirect URL for one-off
  // deposits — instead they return bank details the customer must transfer
  // to directly, plus a short expiry window. `pendingDeposit` holds that
  // state so we can render it inline instead of the old
  // `window.location.href = res.authorizationUrl` (which broke with a
  // null URL for these gateways).
  const [pendingDeposit, setPendingDeposit] = useState(null);
  const [secondsLeft,    setSecondsLeft]    = useState(0);
  const [checking,       setChecking]       = useState(false);
  const [copiedField,    setCopiedField]    = useState(null);
  const [resumeCheckout, setResumeCheckout] = useState(null);

  const handleCopyField = async (value, field) => {
    await navigator.clipboard.writeText(String(value)).catch(() => {});
    setCopiedField(field);
    toast.success(field === "account" ? "Account number copied" : "Amount copied");
    setTimeout(() => setCopiedField(null), 2000);
  };

  const { fees, limits } = useTradingConfig({ enabled: isAuthenticated });
  const percentFee       = fees.depositFeePercent || 0;
  const minDeposit       = limits.minDepositNGN   || 100;

  const rawAmount    = Number(amount) || 0;
  const isValid      = rawAmount >= minDeposit;
  const feeAmount    = Math.round((percentFee / 100) * rawAmount);
  const chargeAmount = rawAmount + feeAmount;

  // ── Load user (for KYC check) ─────────────────────────────
  useEffect(() => {
    if (!isAuthenticated) { setUserLoading(false); return; }
    getUser()
      .then(d => { if (d?.status) setUser(d.user); })
      .catch(console.error)
      .finally(() => setUserLoading(false));
  }, [isAuthenticated]);

  // ── Handle Paystack redirect back ─────────────────────────
  useEffect(() => {
    const reference = searchParams.get("reference");
    if (!reference) return;
    (async () => {
      setVerifying(true);
      try {
        const res = await verifyDeposit(reference);
        if (res.status) {
          setVerifiedAmount(res.amount);
          setVerified(true);
          const sym = res.symbol || "₦";
          toast.success(`${sym}${res.amount.toLocaleString()} added to your wallet!`);
        } else if (res.code === "VERIFY_PENDING") {
          // Backend couldn't reach Paystack but tx may still complete via webhook
          toast.info(res.message || "Payment is being confirmed — check your balance in a moment.");
          navigate("/home");
        } else {
          toast.error(res.message || "Payment could not be confirmed");
        }
      } catch (err) {
        const data = err?.response?.data;
        if (data?.code === "VERIFY_PENDING") {
          toast.info(data.message || "Payment is being confirmed — check your balance shortly.");
          navigate("/home");
        } else {
          toast.error(data?.message || "Could not verify payment. Check your balance — it may already be credited.");
        }
      } finally { setVerifying(false); }
    })();
  }, []);

  useEffect(() => {
  const saved = loadPendingDeposit();
  if (saved) {
    setPendingDeposit(saved.deposit);
    setSecondsLeft(Math.max(0, Math.round((saved.expiresAt - Date.now()) / 1000)));
  }
}, []);

  const handleDeposit = async () => {
    if (!isValid || loading) return;
    track.addToCart(rawAmount);
    setLoading(true);
    try {
      const res = await initializeDeposit(rawAmount);
      if (!res.status) {
        toast.error(res.message || "Could not start payment");
        return;
      }
      if (res.authorizationUrl) {
        try {
          localStorage.setItem("easwallet_pending_checkout", JSON.stringify({
            url: res.authorizationUrl,
            reference: res.reference,
            amount: rawAmount,
            createdAt: Date.now(),
            // Paystack/hosted sessions are typically valid ~30 min; adjust to what your gateway guarantees
            expiresAt: Date.now() + (res.expiresInSeconds ? res.expiresInSeconds * 1000 : 30 * 60 * 1000),
          }));
        } catch {}
        window.location.href = res.authorizationUrl;
      } else if (res.accountNumber) {
        // Gateway returned bank details directly (IvoryPay, mode: API) —
        // no redirect URL exists for this path, so show them inline instead.
        const expiresInSeconds = res.expiresInSeconds || 600;
        const expiresAt = Date.now() + expiresInSeconds * 1000;
        setPendingDeposit(res);
        setSecondsLeft(expiresInSeconds);
        savePendingDeposit(res, expiresAt);
      } else {
        // Neither shape present — genuinely unexpected response.
        toast.error("Could not start payment: unexpected response from payment provider.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to initialize payment");
    } finally { setLoading(false); }
  };

  // ── Countdown for the inline bank-transfer window ──
  useEffect(() => {
  if (!pendingDeposit) return;
  const saved = loadPendingDeposit();
  const expiresAt = saved?.expiresAt ?? (Date.now() + secondsLeft * 1000);
  const tick = () => {
    const remaining = Math.max(0, Math.round((expiresAt - Date.now()) / 1000));
    setSecondsLeft(remaining);
  };
  tick();
  const interval = setInterval(tick, 1000);
  return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [pendingDeposit]);

  // ── Auto-poll verification every 8s while the window is open ────
  useEffect(() => {
    if (!pendingDeposit || secondsLeft <= 0) return;
    const interval = setInterval(() => handleCheckTransfer(true), 8000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingDeposit]);

  useEffect(() => {
  try {
    const raw = localStorage.getItem("easwallet_pending_checkout");
    if (!raw) return;
    const saved = JSON.parse(raw);
    if (saved.expiresAt > Date.now()) {
      setResumeCheckout(saved);
    } else {
      localStorage.removeItem("easwallet_pending_checkout");
    }
  } catch {}
}, []);

  const handleCheckTransfer = async (silent = false) => {
    if (!pendingDeposit || checking) return;
    setChecking(true);
    try {
      const res = await verifyDeposit(pendingDeposit.reference);
      if (res.status) {
        setVerifiedAmount(res.amount);
        setVerified(true);
        setPendingDeposit(null);
        clearPendingDeposit();
        localStorage.removeItem("easwallet_pending_checkout");
        const sym = res.symbol || "₦";
        toast.success(`${sym}${res.amount.toLocaleString()} added to your wallet!`);
      } else if (res.code === "DEPOSIT_EXPIRED") {
        setPendingDeposit(null);
        clearPendingDeposit();
        toast.error(res.message || "This deposit window has expired. Please start a new deposit.");
      } else if (!silent) {
        // Manual "I've sent it" click, but not confirmed yet — this is
        // expected right after a real transfer (bank confirmation can take
        // a few seconds to a couple minutes), so don't scare the user.
        toast.info("We haven't seen your transfer land yet — this can take a minute. We'll keep checking automatically.");
      }
    } catch (err) {
      const data = err?.response?.data;
      if (data?.code === "DEPOSIT_EXPIRED") {
        setPendingDeposit(null);
        toast.error(data.message || "This deposit window has expired. Please start a new deposit.");
      } else if (!silent) {
        toast.error(data?.message || "Could not check payment status yet.");
      }
    } finally { setChecking(false); }
  };

  const formatCountdown = (s) => {
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}:${String(r).padStart(2, "0")}`;
  };

  // ── Pending bank transfer screen (IvoryPay-style: no redirect, we ──
  // show the account details ourselves and wait for the transfer) ────
  if (pendingDeposit) {
    const expired = secondsLeft <= 0;
    return (
      <div className="min-h-screen bg-bg flex flex-col pb-10">
        <div className="px-5 pt-16 pb-10 text-center" style={{ background: "var(--gradient-hero)" }}>
          <div className="w-16 h-16 bg-white/20 rounded-full border-4 border-white/30 flex items-center justify-center mx-auto mb-4">
            <i className="ri-bank-line text-white text-2xl" />
          </div>
          <h1 className="text-white text-xl font-bold mb-1 font-display">Complete your transfer</h1>
          <p className="text-sm" style={{ color: "var(--gradient-hero-text-muted)" }}>
            Send exactly the amount below to confirm your deposit
          </p>
        </div>

        <div className="px-5 -mt-6 space-y-4">
          <div className="bg-surface rounded-2xl border border-border p-5 space-y-4 shadow-card">
            {!expired ? (
              <div className="flex items-center justify-center gap-2 text-sm font-semibold"
                style={{ color: secondsLeft < 60 ? "var(--color-danger-text)" : "var(--color-secondary)" }}>
                <i className="ri-time-line" />
                Expires in {formatCountdown(secondsLeft)}
              </div>
            ) : (
              <div className="flex items-center justify-center gap-2 text-sm font-semibold text-danger-text">
                <i className="ri-alarm-warning-line" />
                This deposit window has expired
              </div>
            )}

            {!expired && (
              <>
                <div className="flex justify-between items-center py-2 border-b border-border">
                  <span className="text-muted text-xs">Bank</span>
                  <span className="text-primary font-semibold text-sm">{pendingDeposit.bankName}</span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-border">
                  <span className="text-muted text-xs">Account Number</span>
                  <button
                  onClick={() => handleCopyField(pendingDeposit.accountNumber, "account")}className="flex items-center gap-1.5 text-primary font-bold text-base tracking-wide"
                  >
                    {pendingDeposit.accountNumber}
                    <i className={`${copiedField === "account" ? "ri-check-line text-brand" : "ri-file-copy-line text-muted"} text-sm`} />
                  </button>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-border">
                  <span className="text-muted text-xs">Account Name</span>
                  <span className="text-primary font-semibold text-sm">{pendingDeposit.accountName}</span>
                </div>
                <div className="flex justify-between items-center py-2">
                  <span className="text-muted text-xs">Amount to transfer</span>
                  <button
                  onClick={() => handleCopyField(pendingDeposit.amountToTransfer, "amount")}className="flex items-center gap-1.5 text-primary font-bold text-lg"
                  >
                    ₦{Number(pendingDeposit.amountToTransfer).toLocaleString()}
                    <i className={`${copiedField === "amount" ? "ri-check-line text-brand" : "ri-file-copy-line text-muted"} text-base`} />
                  </button>
                </div>
                <p className="text-muted text-[10px] leading-relaxed">
                  Transfer exactly this amount from any Nigerian bank. We'll credit your wallet automatically once the transfer is confirmed — usually within a minute.
                </p>
              </>
            )}
          </div>

          {!expired ? (
            <button onClick={() => handleCheckTransfer(false)} disabled={checking}
              className="w-full bg-brand hover:bg-brand-hover disabled:opacity-60 text-on-brand py-4 rounded-2xl font-bold text-sm transition-all active:scale-95 flex items-center justify-center gap-2">
              {checking
                ? <><div className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />Checking…</>
                : <><i className="ri-checkbox-circle-line" />I've made the transfer</>}
            </button>
          ) : (
            <button onClick={() => { setPendingDeposit(null); clearPendingDeposit(); setAmount(""); }}
              className="w-full bg-brand hover:bg-brand-hover text-on-brand py-4 rounded-2xl font-bold text-sm transition-all active:scale-95">
              Start a new deposit
            </button>
          )}

          <button onClick={() => {setPendingDeposit(null); clearPendingDeposit();} }
            className="w-full text-muted py-2 text-sm font-medium hover:text-secondary transition-colors">
            Cancel
          </button>
        </div>
      </div>
    );
  }

  // ── Verifying screen ──────────────────────────────────────
  if (verifying) {
    return (
      <div className="min-h-screen bg-bg flex flex-col items-center justify-center p-8 text-center">
        <div className="w-16 h-16 border-4 border-t-transparent rounded-full animate-spin mb-6" style={{ borderColor: "var(--color-brand)", borderTopColor: "transparent" }} />
        <h2 className="text-primary font-bold text-lg mb-2 font-display">Confirming your payment…</h2>
        <p className="text-muted text-sm">Please wait, do not close this page</p>
      </div>
    );
  }

  // ── Success screen ────────────────────────────────────────
  if (verified) {
    
    return (
      <div className="min-h-screen bg-bg flex flex-col pb-10">
        <div className="px-5 pt-16 pb-12 text-center relative overflow-hidden" style={{ background: "var(--gradient-hero)" }}>
          <div className="absolute inset-0 pointer-events-none" style={{ background: "var(--gradient-hero-sheen)" }} />
          <div className="absolute top-0 right-0 w-40 h-40 rounded-full opacity-10"
            style={{ background: "radial-gradient(circle, #fff 0%, transparent 70%)", transform: "translate(30%,-30%)" }} />
          <div className="relative">
            <div className="w-20 h-20 bg-white/20 rounded-full border-4 border-white/30 flex items-center justify-center mx-auto mb-4">
              <i className="ri-checkbox-circle-fill text-white text-4xl" />
            </div>
            <h1 className="text-white text-2xl font-bold mb-1 font-display">
              Deposit Successful!
            </h1>
            <p className="text-sm mb-4" style={{ color: "var(--gradient-hero-text-muted)" }}>Your wallet has been credited</p>
            <p className="text-white text-4xl font-bold font-display">
              ₦{verifiedAmount.toLocaleString()}
            </p>
          </div>
        </div>
        <div className="px-5 mt-6 space-y-3">
          <div className="bg-surface rounded-2xl border border-border p-4">
            {[
              { label: "Credited to wallet", value: `₦${verifiedAmount.toLocaleString()}` },
              { label: "Type",   value: "Naira Deposit" },
              { label: "Status", value: "✅ Confirmed" },
              { label: "Time",   value: new Date().toLocaleString("en-NG", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) },
            ].map(row => (
              <div key={row.label} className="flex justify-between items-center py-3 border-b border-border last:border-0">
                <span className="text-muted text-sm">{row.label}</span>
                <span className="text-primary font-semibold text-sm">{row.value}</span>
              </div>
            ))}
          </div>
          <button onClick={() => navigate("/home")}
            className="w-full bg-brand hover:bg-brand-hover text-on-brand py-4 rounded-2xl font-bold text-sm transition-all active:scale-95">
            Back to Home
          </button>
          <button onClick={() => { setVerified(false); setAmount(""); navigate("/deposit-fiat", { replace: true }); }}
            className="w-full text-muted py-3 text-sm font-medium hover:text-secondary transition-colors">
            Make Another Deposit
          </button>
        </div>
      </div>
    );
  }

  // ── Main deposit form ─────────────────────────────────────
  return (
    <ServiceGate serviceKey="fiat_deposit" services={services} fullPage>
      <div className="min-h-screen bg-bg pb-10 font-display">

        <FloatingSupportButton user={user} />

        {/* Header */}
        <div className="bg-surface px-5 pt-12 pb-4 border-b border-border">
          <div className="flex items-center gap-3">
            <button onClick={() => navigate(-1)} className="w-9 h-9 rounded-xl bg-surface-hover flex items-center justify-center">
              <i className="ri-arrow-left-line text-secondary text-lg" />
            </button>
            <div>
              <h1 className="text-primary font-bold text-lg">Fund Wallet</h1>
              <p className="text-muted text-xs">Choose how you want to deposit Naira</p>
            </div>
          </div>

          {/* Method tabs */}
          <div className="flex mt-4 bg-surface-hover rounded-2xl p-1 gap-1">

            <button onClick={() => setActiveTab("transfer")}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-semibold transition-all ${
                activeTab === "transfer" ? "bg-surface text-primary shadow-card" : "text-muted"
              }`}>
              <i className="ri-bank-line" />Bank Transfer
            </button>

            <button onClick={() => setActiveTab("paystack")}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-semibold transition-all ${
                activeTab === "paystack" ? "bg-surface text-primary shadow-card" : "text-muted"
              }`}>
              <i className="ri-bank-card-line" />Pay with Card / USSD
            </button>
            
          </div>
        </div>

        <div className="px-5 pt-5 space-y-5">

          {resumeCheckout && (
            <div className="bg-brand-light border border-brand-border rounded-2xl p-4 flex items-center justify-between gap-3">
              <div>
                <p className="text-brand-text text-sm font-semibold">Payment in progress</p>
                <p className="text-brand-text text-xs opacity-90">
                  You have an unfinished ₦{resumeCheckout.amount?.toLocaleString()} payment.
                </p>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => { window.location.href = resumeCheckout.url; }}
                  className="px-3 py-2 bg-brand text-on-brand text-xs font-bold rounded-xl"
                >
                  Resume
                </button>
                <button
                  onClick={() => { localStorage.removeItem("easwallet_pending_checkout"); setResumeCheckout(null); }}
                  className="px-3 py-2 text-brand-text text-xs font-semibold"
                >
                  Dismiss
                </button>
              </div>
            </div>
          )}

          {/* ── TAB: PAYSTACK ─────────────────────────────── */}
          {activeTab === "paystack" && (
            <>
              {/* Info banner */}
              <div className="bg-brand-light border border-brand-border rounded-2xl p-4 flex items-start gap-3">
                <i className="ri-shield-check-line text-brand text-xl mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-brand-text text-sm font-semibold">Secure payment</p>
                  <p className="text-brand-text text-xs mt-0.5 opacity-90">
                    Pay with card, bank transfer, or USSD. Funds reflect instantly after confirmation.
                  </p>
                </div>
              </div>

              {/* Amount input */}
              <div>
                <p className="text-secondary text-sm font-semibold mb-3">
                  Amount to credit <span className="text-muted font-normal">(min ₦{minDeposit.toLocaleString()})</span>
                </p>
                <div className={`bg-surface border-2 rounded-2xl flex items-center px-4 transition-colors ${
                  amount && !isValid ? "border-danger-border" : "border-border-strong focus-within:border-brand"
                }`}>
                  <span className="text-muted font-bold text-lg mr-2">₦</span>
                  <input
                    type="number"
                    value={amount}
                    onChange={e => setAmount(e.target.value)}
                    onKeyDown={e => e.key === "Enter" && handleDeposit()}
                    placeholder="0.00"
                    className="flex-1 py-4 outline-none text-primary text-xl font-bold bg-transparent placeholder:text-faint"
                  />
                </div>
                {amount && !isValid && (
                  <p className="text-danger-text text-xs mt-1.5 px-1">Minimum deposit is ₦{minDeposit.toLocaleString()}</p>
                )}
              </div>

              {/* Quick amounts */}
              <div>
                <p className="text-muted text-xs font-semibold mb-2">Quick amounts</p>
                <div className="grid grid-cols-3 gap-2">
                  {QUICK_AMOUNTS.map(amt => (
                    <button key={amt} onClick={() => setAmount(String(amt))}
                      className={`py-2.5 rounded-xl text-sm font-semibold border transition-all ${
                        amount === String(amt) ? "bg-brand text-on-brand border-brand" : "bg-surface text-secondary border-border-strong hover:border-brand-border"
                      }`}>
                      ₦{amt >= 1000 ? `${amt / 1000}k` : amt}
                    </button>
                  ))}
                </div>
              </div>

              {/* Fee breakdown */}
              {isValid && (
                <div className="bg-surface-muted border border-border rounded-2xl p-4 space-y-2.5">
                  <div className="flex justify-between text-sm">
                    <span className="text-muted">Wallet credit</span>
                    <span className="font-semibold text-primary">₦{rawAmount.toLocaleString()}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-muted">Service fee ({percentFee}%)</span>
                    <span className="font-semibold text-danger-text">+ ₦{feeAmount.toLocaleString()}</span>
                  </div>
                  <div className="h-px bg-border" />
                  <div className="flex justify-between text-sm">
                    <span className="text-primary font-bold">You pay</span>
                    <span className="font-bold text-primary text-base">₦{chargeAmount.toLocaleString()}</span>
                  </div>
                  <p className="text-muted text-[10px] leading-relaxed">
                    ₦{rawAmount.toLocaleString()} will be credited to your wallet. The ₦{feeAmount.toLocaleString()} fee covers payment processing.
                  </p>
                </div>
              )}

              {/* Pay button */}
              <button onClick={handleDeposit} disabled={!isValid || loading}
                className="w-full bg-brand hover:bg-brand-hover disabled:bg-surface-hover disabled:text-faint text-on-brand py-4 rounded-2xl font-bold text-sm transition-all active:scale-95 flex items-center justify-center gap-2">
                {loading
                  ? <><div className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />Processing…</>
                  : isValid
                    ? <><i className="ri-bank-card-line" />Pay ₦{chargeAmount.toLocaleString()}</>
                    : "Enter an amount to continue"}
              </button>

              <p className="text-center text-xs text-muted pb-2">
                🔒 Your payment is encrypted and securely processed
              </p>
            </>
          )}

          {/* ── TAB: BANK TRANSFER (Virtual Account) ─────── */}
          {activeTab === "transfer" && (
  <>
    {/* Updated banner — shows actual fee */}
    <div className="bg-surface-muted border border-border rounded-2xl p-4 flex items-start gap-3">
      <i className="ri-bank-line text-muted text-xl mt-0.5 flex-shrink-0" />
      <div>
        <p className="text-secondary text-sm font-semibold">Direct Bank Transfer</p>
        <p className="text-muted text-xs mt-0.5 leading-relaxed">
          Transfer to your dedicated account number below.
          {percentFee > 0
            ? ` A ${percentFee}% fee applies — transferring ₦10,000 credits ₦${(10000 - Math.round(10000 * percentFee / 100)).toLocaleString()} to your wallet.`
            : " Your full transfer amount is credited instantly."}
        </p>
      </div>
    </div>

    {userLoading ? (
      <div className="h-40 bg-surface-hover rounded-2xl animate-pulse" />
    ) : (
      <VirtualAccountSection user={user} percentFee={percentFee} />
    )}
  </>
)}

        </div>
      </div>
    </ServiceGate>
  );
}